import styled from 'styled-components'

export const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 14rem);
  gap: 6rem;
  margin-bottom: 8rem;

  @media (max-width: 1279px) {
    gap: 1.6rem;
  }

  @media (max-width: 999px) {
    display: flex;
    gap: 2.4rem;

    label {
      width: auto;
    }
  }

  @media (max-width: 767px) {
    width: 29rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    row-gap: 3rem;
    margin-bottom: 6rem;
  }
`
